import db from '../../versa/db.js';
import * as types from '../types.js';

// Requires pubsub.js
export default function (...args)
{
	return {

		async actions(ev, publisher, category_id)
		{
				
			let company_id = this.locate('company_id').getValue();
			const catId = category_id != null && category_id !== '' ? Number(category_id) : null;
			if (!company_id || company_id === '' || catId == null || catId < 0)
				return;

			let category = await db.get('categories', [company_id, catId], 1);
			if (!category || !category.attributes)
				return;

			const attr = category.attributes[0];
			const lengths = attr.lengths && attr.lengths.length ? attr.lengths : [attr.length];
			this.form.fields[this.getId()].releaseEvents();
			this.form.fields[this.getId()] = (this?.type == 'sku' ? this.scrapeTypes(1) : this).appendType(types.sku(lengths));
			this.form.fields[this.getId()].captureEvents();
			this.form.fields[this.getId()].refresh();

		}

	};
}


